var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5232_35532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.05362 12.9953L17.9166 21.7769C18.0306 21.879 18.1689 21.9493 18.3179 21.981C18.4668 22.0127 18.6214 22.0046 18.7664 21.9576C18.9113 21.9106 19.0417 21.8262 19.1447 21.7127C19.2477 21.5993 19.3198 21.4607 19.3538 21.3106L23.479 3.08142C23.5136 2.92443 23.5054 2.76088 23.4553 2.60823C23.4052 2.45558 23.3151 2.31957 23.1945 2.2147C23.074 2.10984 22.9276 2.04007 22.7709 2.01283C22.6143 1.98559 22.4533 2.00191 22.3051 2.06005L2.05244 10.1089C1.24058 10.4308 1.35029 11.6298 2.20604 11.8074L8.05362 12.9953Z",
    stroke: "#F8D210",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13L23 2.5",
    stroke: "#F8D210",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.3236L9.02561 20.7388C8.90166 20.8625 8.74309 20.9472 8.57005 20.9821C8.39701 21.017 8.21731 21.0006 8.05379 20.9349C7.89027 20.8692 7.75032 20.7572 7.65171 20.6131C7.5531 20.4691 7.5003 20.2994 7.5 20.1258V13",
    stroke: "#F8D210",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5232_35532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowTelegram);
export default __webpack_public_path__ + "static/media/yellowTelegram.f32726668bdf25029c0c3d71d61913c3.svg";
export { ForwardRef as ReactComponent };